import { ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnInit, Optional, Renderer2 } from "@angular/core";
import { ButtonShape, ButtonSize, ButtonType } from "./button.models";
import { NzButtonComponent } from "ng-zorro-antd/button";
import { fromEvent, takeUntil } from "rxjs";
import { NzConfigService } from "ng-zorro-antd/core/config";
import { Directionality } from "@angular/cdk/bidi";
import { DestroyService } from "@webapp/core/util/services/destroy.service";

/**
 * NO LEGACY!
 */

/**
 * This component extends the base Button directive of NG-Zorro
 * Example usage : https://ng.ant.design/components/button/en
 *
 * @param disabled boolean (default: false)
 * @param buttonGhost boolean (default: false)
 * @param buttonLoading boolean (default: false)
 * @param buttonShape 'circle'|'round'|'rectangle' - (default: 'rectangle')
 * @param buttonSize 'large'|'small'|'default' (default: 'default')
 * @param buttonType 'primary'|'dashed'|'link'|'text' (default: 'default')
 * @param buttonBlock boolean (default: false) - Option to fit button width to its parent width
 * @param buttonDanger boolean (default: false)
 *
 */

@Component({
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.less"],
  selector: "button[ui-button], a[ui-button], ui-button",
  exportAs: "uiButton",
  preserveWhitespaces: false,
  host: {
    class: "ant-btn",
    "[class.ant-btn-primary]": `nzType === 'primary'`,
    "[class.ant-btn-dashed]": `nzType === 'dashed'`,
    "[class.ant-btn-link]": `nzType === 'link'`,
    "[class.ant-btn-text]": `nzType === 'text'`,
    "[class.ant-btn-circle]": `nzShape === 'circle'`,
    "[class.ant-btn-round]": `nzShape === 'round'`,
    "[class.ant-btn-lg]": `nzSize === 'large'`,
    "[class.ant-btn-sm]": `nzSize === 'small'`,
    "[class.ant-btn-dangerous]": `nzDanger`,
    "[class.ant-btn-loading]": `nzLoading`,
    "[class.ant-btn-background-ghost]": `nzGhost`,
    "[class.ant-btn-block]": `nzBlock`,
    "[class.ant-input-search-button]": `nzSearch`,
    "[class.ant-btn-rtl]": `dir === 'rtl'`,
    "[attr.tabindex]": "disabled ? -1 : (tabIndex === null ? null : tabIndex)",
    "[attr.disabled]": "disabled || null",
  },
  providers: [DestroyService],
})
export class UiButtonComponent extends NzButtonComponent implements OnInit {
  @Input("buttonGhost")
  public nzGhost = false;
  @Input("buttonLoading")
  public nzLoading = false;
  @Input("buttonBlock")
  public nzBlock = false;
  @Input("buttonDanger")
  public nzDanger = false;
  @Input("buttonShape")
  nzShape: ButtonShape;
  @Input("buttonSize")
  nzSize: ButtonSize;
  @Input("buttonType")
  nzType: ButtonType;

  constructor(
    private ghNgZone: NgZone,
    private ghElementRef: ElementRef,
    ghCdr: ChangeDetectorRef,
    ghRenderer: Renderer2,
    ghNzConfigService: NzConfigService,
    private destroyService$: DestroyService,
    @Optional() ghDirectionality: Directionality
  ) {
    super(ghNgZone, ghElementRef, ghCdr, ghRenderer, ghNzConfigService, ghDirectionality);
  }
  ngOnInit(): void {
    // Without tabIndex focus is not applied in Ajs buttons.
    // It can be removed when there are no downgraded buttons in Ajs.
    this.tabIndex = 1;
    super.ngOnInit();

    this.ghNgZone.runOutsideAngular(() => {
      fromEvent<MouseEvent>(this.ghElementRef.nativeElement, "click", { capture: true })
        .pipe(takeUntil(this.destroyService$))
        .subscribe((event) => {
          if (this.disabled || this.nzLoading) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        });
    });
  }
}
